import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Intro from "../../elements/blocks/intro";
import Nope from "../../elements/blocks/nope";
import { useApiCentral } from "../../../api/api-central";
import { useTenancy } from "../../../services/tenancy";
import { usePrefs } from "../../../services/prefs";
export default function ThreeCX() {
    const { t } = useTranslation();
    const { callerDisplayName, callerNumber, sessionId, ticketId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const api = useApiCentral();
    const tenancy = useTenancy();
    const prefs = usePrefs();
    const [isLoading, setIsLoading] = useState(true);
    const [isInValid, setIsInValid] = useState(false);
    useEffect(() => {
        var _a, _b;
        const querySessionId = (_b = (_a = searchParams.get("session_id")) !== null && _a !== void 0 ? _a : searchParams.get("sessionId")) !== null && _b !== void 0 ? _b : "";
        const resolvedSessionId = (sessionId !== null && sessionId !== void 0 ? sessionId : querySessionId).trim();
        const invalidate = () => {
            prefs.setSessionId(null);
            setIsLoading(false);
            setIsInValid(true);
        };
        const queue = (callerDisplayName === null || callerDisplayName === void 0 ? void 0 : callerDisplayName.includes(":"))
            ? callerDisplayName.split(":").slice(-1)[0]
            : callerDisplayName;
        if (!queue) {
            invalidate();
            return;
        }
        api.GET_queue(queue)
            .then(response => {
            const client = response.data.tenant;
            const campaign = response.data.campaign;
            if (client && campaign) {
                api.GET_tenantToken(client.id)
                    .then(response => {
                    prefs.setTenantToken(response.data.token);
                    tenancy.setClient(client);
                    prefs.setSessionId(resolvedSessionId !== "" ? resolvedSessionId : null);
                    if (ticketId) {
                        navigate("/" + client.domain + "/tickets/" + ticketId);
                    }
                    else if (callerNumber) {
                        navigate("/" +
                            client.domain +
                            "/campaigns/" +
                            campaign.id +
                            "/new-ticket/" +
                            callerNumber);
                    }
                    else {
                        navigate("/" +
                            client.domain +
                            "/campaigns/" +
                            campaign.id +
                            "/new-ticket");
                    }
                })
                    .catch(error => {
                    console.error(error);
                    invalidate();
                });
            }
            else {
                invalidate();
            }
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                invalidate();
            }
        });
        return () => api.cancel();
    }, []);
    return (_jsxs(Fragment, { children: [isLoading && (_jsx(Backdrop, Object.assign({ invisible: true, open: true }, { children: _jsx(CircularProgress, { color: "inherit" }) }))), isInValid && (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("tickets.new-ticket"), breadcrumbs: [
                            {
                                name: "3CX",
                                link: "/3cx",
                            },
                        ] }), _jsx(Nope, { title: t("errors.404"), caption: t("errors.queues.not-found") })] }))] }));
}
